import { forwardRef, type ReactNode } from 'react'
import { MENU_PAGE_HEIGHT_MM, MENU_PAGE_WIDTH_MM, menuPageScale } from '@/lib/menuPageMetrics'

type MenuFlipPageProps = {
  children: ReactNode
  pageWidthPx: number
}

export const MenuFlipPage = forwardRef<HTMLDivElement, MenuFlipPageProps>(function MenuFlipPage(
  { children, pageWidthPx },
  ref,
) {
  const scale = menuPageScale(pageWidthPx)

  return (
    <div ref={ref} className="menu-flip-page">
      <div
        className="menu-flip-page__content"
        style={{
          width: `${MENU_PAGE_WIDTH_MM}mm`,
          height: `${MENU_PAGE_HEIGHT_MM}mm`,
          transform: `scale(${scale})`,
        }}
      >
        {children}
      </div>
    </div>
  )
})
